module.exports = __webpack_public_path__ + "img/icon-cart.7ef098e7.svg";